import type { IconData } from '@stacksjs/iconify-core'

export const ticketF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 9v11H8.83a3.001 3.001 0 0 0-5.66 0H0V9h4a1 1 0 1 0 0-2H0V0h3.17a3.001 3.001 0 0 0 5.66 0H12v7H8a1 1 0 1 0 0 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default ticketF
